export const slugs = {
  login: "/login",
  paymentMethods: "/payment-methods/:accountId?",
  allInvoices: "/account/:accountId/invoices?",
  payInvoices: `/account/:accountId/payment`,
  invoice: "/account/:accountId/invoices/:invoiceId",
  securityDeposit: "/account/:accountId/security-deposit",
};
